import { render } from "./TheUserGenerals.vue?vue&type=template&id=b53de33c"
import script from "./TheUserGenerals.vue?vue&type=script&lang=js"
export * from "./TheUserGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__